/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Download_PptxInputs */



/**
* | output |
* | --- |
* | "PowerPoint (.pptx)" |
*
* @param {Presentation_Download_PptxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_download_pptx = /** @type {((inputs?: Presentation_Download_PptxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Download_PptxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("PowerPoint (.pptx)")
	return /** @type {LocalizedString} */ ("PowerPoint (.pptx)")
});